import styled from 'styled-components'
import { NegativeIcon } from '@shipt/design-system-icons'
import { screenSizes } from '@shipt/design-system-themes'
import { useOnChangeFilter } from '@/features/shop/components/ProductFilter/interactions/useOnChangeFilter'
import { getResetSearchParams } from '@/features/shop/components/ProductFilter/utils/getResetSearchParams'
import { type SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { IconButton } from '@shipt/design-system-buttons'

interface Props {
  filterType: SEARCH_FILTER_TYPE
  className?: string
}

export const ResetFilterButton = ({ filterType, className }: Props) => {
  const { onChangeFilter } = useOnChangeFilter()

  const handleOnResetFilter = (e: React.MouseEvent) => {
    e.stopPropagation()
    return onChangeFilter(getResetSearchParams(filterType))
  }

  return (
    <ResetButton
      className={className}
      onClick={handleOnResetFilter}
      aria-label={`reset ${filterType} filter`}
      variant="ghost"
      icon={NegativeIcon}
    />
  )
}

const ResetButton = styled(IconButton)`
  position: absolute;
  top: 0.5625rem;
  right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 50%;
  padding: 8px;
  margin-left: 4px;

  @media ${screenSizes.max_mobile} {
    top: 0;
    width: 28px;
    height: 28px;

    & svg {
      min-width: 16px;
      min-height: 16px;
    }
  }
`
